// dashbaord
import Social from "../Components/Dashboard/Social";
import ErrorPage4 from '../Components/Pages/ErrorPages/ErrorPage404';
import AddQuestions from "../Pages/AddQuestion";
import Category from "../Pages/Category";
import ExaminationPage from "../Pages/Examination";
import EditQuestions from "../Pages/EditQuestions";
import Lessons from "../Pages/Lessons";
import MockTest from "../Pages/MockTest";
import Page from "../Pages/Page";
import PageEdit from "../Pages/PageEdit";
import PreviewTest from "../Pages/PreviewTest/PreviewTest";
import PreviousYearQuestion from "../Pages/PreviousYearQuestion";
import Questions from "../Pages/Questions";
import Settings from "../Pages/Settings";
import Sliders from "../Pages/Sliders";
import Testseries from "../Pages/TestSeries";
import Faqs from "../Pages/Faqs";
import UserList from "../Pages/Users";
import ExamList from "../Pages/ExamList";
import StudentPreviewTest from "../Pages/StudentPreviewTest/StudentPreviewTest";
import RecordedSubject from "../Pages/RecordedSubject";
import RecordedChapter from "../Pages/RecordedChapter";
import RecordedLessons from "../Pages/RecordedLessons";
import RecordedQuestions from "../Pages/RecordedQuestions";
import LiveSubject from "../Pages/LiveSubject";
import LiveChapter from "../Pages/LiveChapter";
import LiveLessons from "../Pages/LiveLessons";
import RecordedClass from "../Pages/RecordedClass";
import EnotesSubject from "../Pages/EnotesSubject";
import EnoteChapter from "../Pages/EnoteChapter";
import LiveQuestions from "../Pages/LiveQuestions";
import LiveClass from "../Pages/LiveClass";
import Subscription from "../Pages/Subscription";
import BodmasCategory from "../Pages/BodmasCategory";
import BodmasTestSeries from "../Pages/BodmasTestSeries";
import BodmasTestLessons from "../Pages/BodmasTestLessons";
import BodmasTestQuestions from "../Pages/BodmasTestQuestions";
import BodmasAddQuestions from "../Pages/BodmasTestAddQuestion";
import BodmasEditQuestions from "../Pages/BodmasEditQuestions";
import GKShorts from "../Pages/GKShorts";
import Teachers from "../Pages/Teachers";
import TeacherApplications from "../Pages/TeacherApplications";
import Transaction from "../Pages/Transaction";
import TransactionDetails from "../Pages/TransactionDetails";
import HelpSupport from "../Pages/HelpSupport";
import Enquiry from "../Pages/Enquiry";
import Enotes from "../Pages/Enotes";
import Coupons from "../Pages/Coupons";
import BodmasPreviewTest from "../Pages/BodmasPreviewTest/PreviewTest";
import DeviceChange from "../Pages/DeviceChange";
import ClassReport from "../Pages/ClassReport";
import ExamAttempts from "../Pages/ExamAttempts";
import PopupModal from "../Pages/PopupModal";


export const routes = [
  { path: `/dashboard/:layout`, Component: <Social /> },
  { path: `/test-series/:layout`, Component: <Category /> },
  { path: `/test-details/:layout`, Component: <Testseries /> },
  { path: `/examination/:layout`, Component: <ExaminationPage /> },
  { path: `/mock-test/:layout`, Component: <MockTest /> },
  { path: `/previous-year/:layout`, Component: <PreviousYearQuestion /> },
  { path: `/lessons/:layout`, Component: <Lessons /> },
  { path: `/questions/:layout`, Component: <Questions /> },
  { path: `/add-questions/:layout`, Component: <AddQuestions /> },
  { path: `/edit-questions/:layout`, Component: <EditQuestions /> },
  { path: `/preview-test/:layout`, Component: <PreviewTest /> },
  { path: `/pages/:layout`, Component: <Page /> },
  { path: `/edit-page/:layout`, Component: <PageEdit /> },
  { path: `/settings/:layout`, Component: <Settings /> },
  { path: `/popup-modal/:layout`, Component: <PopupModal /> },
  { path: `/faqs/:layout`, Component: <Faqs /> },
  { path: `/sliders/:layout`, Component: <Sliders /> },
  { path: `/user-list/:layout`, Component: <UserList /> },
  { path: `/device-change/:layout`, Component: <DeviceChange /> },
  { path: `/student-attempts/:layout`, Component: <ExamAttempts /> },
  { path: `/exam-list/:layout`, Component: <ExamList /> },
  { path: `/exam-history/:layout`, Component: <StudentPreviewTest /> },
  { path: `/subscription/:layout`, Component: <Subscription /> },
  { path: `/gk-shorts/:layout`, Component: <GKShorts /> },
  { path: `/teachers/:layout`, Component: <Teachers /> },
  { path: `/teacher-applications/:layout`, Component: <TeacherApplications /> },
  { path: `/class-report/:layout`, Component: <ClassReport /> },
  { path: `/transaction/:layout`, Component: <Transaction /> },
  { path: `/transaction/details/:layout`, Component: <TransactionDetails /> },
  { path: `/help-support/:layout`, Component: <HelpSupport /> },
  { path: `/enquiries/:layout`, Component: <Enquiry /> },
  { path: `/coupons/:layout`, Component: <Coupons /> },
  
  /*********** Recorded Section ***************/
  { path: `/recorded-class/:layout`, Component: <RecordedClass /> },
  { path: `/recorded-subject/:layout`, Component: <RecordedSubject /> },
  { path: `/recorded-chapter/:layout`, Component: <RecordedChapter /> },
  { path: `/recorded-lessons/:layout`, Component: <RecordedLessons /> },
  { path: `/recorded-questions/:layout`, Component: <RecordedQuestions /> },
  
  /**************** Live Section ****************/
  { path: `/live-class/:layout`, Component: <LiveClass /> },
  { path: `/live-subject/:layout`, Component: <LiveSubject /> },
  { path: `/live-chapter/:layout`, Component: <LiveChapter /> },
  { path: `/live-lessons/:layout`, Component: <LiveLessons /> },
  { path: `/live-questions/:layout`, Component: <LiveQuestions /> },
  
  /******************Enotes Section  ********************/
  { path: `/enotes/:layout`, Component: <Enotes /> },
  { path: `/enotes-subject/:layout`, Component: <EnotesSubject /> },
  { path: `/enotes-chapter/:layout`, Component: <EnoteChapter /> },
  
  
  /********************Bodmas TestSeries *******************/
  { path: `/bodmas-category/:layout`, Component: <BodmasCategory /> },
  { path: `/bodmas-testseries/:layout`, Component: <BodmasTestSeries /> },
  { path: `/bodmas-lessons/:layout`, Component: <BodmasTestLessons /> },
  { path: `/bodmas-questions/:layout`, Component: <BodmasTestQuestions /> },
  { path: `/bodmas-add-questions/:layout`, Component: <BodmasAddQuestions /> },
  { path: `/bodmas-edit-questions/:layout`, Component: <BodmasEditQuestions /> },
  { path: `/bodmas-preview-test/:layout`, Component: <BodmasPreviewTest /> },
  



  //Error
  { path: `*`, Component: <ErrorPage4 /> },

];
